document.addEventListener('DOMContentLoaded', function(){

  // menu mobile apps
  (function closeMobileMenu() {
    document.body.addEventListener('click', (e) => {
      const targetEl = e.target;
      
      if(targetEl.closest('.menu_mobile_apps_close-btn')){
        document.getElementById('menu_mobile').dispatchEvent(new Event('dialog:forceClose'));
      }
    })
  })();

  // Inventory status
  let origStatus;
  document.querySelectorAll('hdt-variant-picker input[type=radio]').forEach(el => el.addEventListener('change', e => {
    const el = document.querySelector('hdt-variant-inventory .hdt-stock-status.hdt-stock-success > span');

    if (! origStatus) {
      origStatus = el.dataset.origStatus || el.innerText;
    }

    let status = origStatus;
    
    if (e.srcElement.defaultValue.toLowerCase() == 'ebook only') {
      status = 'Digital Delivery';
    }

    el.innerText = status;
  }));

  // Product options info tooltip
  const touchDevice = ('ontouchstart' in document.documentElement);
  if (! touchDevice && window.innerWidth > 767) {
    const popoverId = 'popover-soccertutor-product-variant';
    document.querySelectorAll(`[aria-controls="${popoverId}"]`).forEach(el => {
        el.addEventListener('mouseover', e => e.srcElement.click());
        el.addEventListener('mouseleave', (e) => document.getElementById(popoverId).dispatchEvent(new Event('dialog:forceClose')));
    });
  }

  // Remove wishlist & cart zero-counters
  const wishlistCounter = document.querySelector('hdt-wishlist-count.hdt-count-box'),
    cartCounter = document.querySelector('hdt-cart-count.hdt-count-box');

  if (wishlistCounter.innerText > 0) {
     wishlistCounter.style.display = 'block';
  }

  if (cartCounter.innerText > 0) {
     cartCounter.style.display = 'block';
  }
  
  document.addEventListener('theme4:wishlist:update', e=>{
    if (wishlistCounter.innerText > 0) {
      wishlistCounter.style.display = 'block';
    } else {
       wishlistCounter.style.display = 'none';
    }
  });

  document.addEventListener('cart:change', e => {
    if (e.detail.cart.item_count > 0) {
      cartCounter.style.display = 'block';
    } else {
       cartCounter.style.display = 'none';
    }
  });

  const updateFreeShippingBar = function () {
    let visibility = 'block';
    let blockedStatus = '';
    document.querySelectorAll('hdt-free-shipping-bar').forEach(el => {
      blockedStatus = el.dataset.visibility;
      if (el.querySelector('hdt-progress-bar').progress) {
        visibility = 'block';
      } else {
        visibility = 'none';
      }
      
      el.style.display = blockedStatus !== 'blocked' ? visibility : 'none';
      const wrapper = el.closest(".hdt-mini-cart__threshold");
      if (wrapper) {
        wrapper.style.display = blockedStatus !== 'blocked' ? visibility : 'none';
      }
    });
    updateCartText(visibility);
  }

  const updateCartText = function(visibility) {
    document.querySelectorAll('.hdt-cart-tax').forEach(el => {
      if (! el.dataset.origText) {
        el.dataset.origText = el.innerText;
      }

      let text = el.dataset.origText;
      if (visibility === 'none') {
        // text = text.replace(' and shipping calculated', '');
        text = 'Tax included';
      }

      el.innerText = text;
    });
  }
  
  document.addEventListener('currency:update', () => {
    updateFreeShippingBar();
  });

  updateFreeShippingBar();
  

  // ------------------------------------------ FAQ Controller ------------------------------------------

  const AccordionController = {
      detailsElements: document.querySelectorAll('.hdt-accordion-item'),
      headerElement: document.querySelector('.hdt-main-header'),
  
      getURLParameter(name) {
          const urlParams = new URLSearchParams(window.location.search);
          return urlParams.get(name);
      },
  
      openElementByIndex(index) {
          if (index >= 0 && index < this.detailsElements.length) {
              this.detailsElements[index].open = true;
  
              setTimeout(() => {
                  this.scrollToElement(this.detailsElements[index]);
              }, 500);
          }
      },
  
      scrollToElement(element) {
          const headerHeight = this.headerElement ? this.headerElement.offsetHeight : 0;
  
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
  
          window.scrollTo({
              top: elementPosition - headerHeight,
              behavior: 'smooth'
          });
      },
  
      init() {
          const dataItemParam = this.getURLParameter('data-item');
          if (dataItemParam) {
              const index = parseInt(dataItemParam, 10) - 1;
              this.openElementByIndex(index);
          }
      }
  };
  
  AccordionController.init();


    const loaderObserver = {
        loadingBarObserver: null,
        loadingBarElement: document.querySelector('.hdt-loading-bar'),
        isLoading: false,
        bodyElement: document.body,
        quantityButtonClicked: false,
        initialInputValue: null,

        initLoadingBarObserver: function () {
            this.loadingBarObserver = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.target.classList.contains('hdt-loading-bar')) {
                        const newValue = mutation.target.getAttribute(mutation.attributeName);
                        this.isLoading = newValue !== "opacity: 0; transform: scaleX(1);";

                        if (this.quantityButtonClicked && !this.isLoading) {
                            this.hideCheckoutLoader();
                        }
                    }
                }
            });

            if (this.loadingBarElement) {
                this.loadingBarObserver.observe(this.loadingBarElement, {attributes: true});
            }
        },

        initButtonClickDelegation: function () {
            document.addEventListener('click', (event) => {
                if (event.target && event.target.matches('.hdt-quantity__button') || event.target.matches('.hdt-mini-cart__remove')) {
                    this.quantityButtonClicked = true;
                    this.showCheckoutLoader();
                }
            });

            document.addEventListener('focus', (event) => {
                if (event.target && event.target.matches('.hdt-quantity-input')) {
                    this.initialInputValue = event.target.value;
                }
            }, true);

            document.addEventListener('keyup', (event) => {
                if (event.target && event.target.matches('.hdt-quantity-input') && (event.key === 'Enter' || event.key === 'ArrowUp' || event.key === 'ArrowDown')) {
                    this.handleQuantityChange(event.target);
                }
            });

            document.addEventListener('blur', (event) => {
                if (event.target && event.target.matches('.hdt-quantity-input')) {
                    this.handleQuantityChange(event.target);
                }
            }, true);
        },

        handleQuantityChange: function(inputElement) {
            if (inputElement.value !== this.initialInputValue) {
                this.quantityButtonClicked = true;
                this.showCheckoutLoader();
            } else {
                this.hideCheckoutLoader();
            }

            this.initialInputValue = null;
        },

        showCheckoutLoader: function () {
            if (this.bodyElement && !this.bodyElement.classList.contains('cart-loading')) {
                console.log('show');
                this.bodyElement.classList.add('cart-loading');

                clearTimeout(this.hideLoaderTimeout);
                clearTimeout(this.failSafeTimeout);

                this.failSafeTimeout = setTimeout(() => {
                    console.log('fail-safe timeout');
                    this.hideCheckoutLoader();
                }, 5000);
            }
        },

        hideCheckoutLoader: function () {
            if (this.bodyElement) {
                console.log('hide');
                this.hideLoaderTimeout = setTimeout(() => {
                    this.bodyElement.classList.remove('cart-loading');
                    this.quantityButtonClicked = false;
                }, 2000);

                clearTimeout(this.failSafeTimeout);
            }
        },

        init: function () {
            this.initLoadingBarObserver();
            this.initButtonClickDelegation();
        }
    };

    loaderObserver.init();

  function removeFreeShippingBar() {
    let shippingBarElement = document.querySelector('.hdt-free-shipping-bar');
    if (shippingBarElement) {
      shippingBarElement.dataset.visibility = 'blocked';
    }
  }

  function showFreeShippingBar() {
    let shippingBarElement = document.querySelector('.hdt-free-shipping-bar');
    if (shippingBarElement) {
      shippingBarElement.dataset.visibility = 'visible';
    }
  }

  (function checkFreeShippingForCountry() {
    const cartPageFormSelector = document.getElementById('ShippingCountry_CartPage-Form');
    // if (cartPageFormSelector) {
    //   cartPageFormSelector.addEventListener('change', async function (event) {
    //     const selectedCountry = event.target.selectedOptions[0].innerText.replace('&', '&amp;');
    //     const selectedCountryCode = countriesInfo[selectedCountry];
    //     const freeShippingProduct = window.SoccerTutor.freeShippingProduct;

    //     if (freeShippingProduct) {
    //       for (let variant of freeShippingProduct.variants) {
    //         if (variant.title.includes(selectedCountryCode)) {
    //           const progressBar = document.getElementsByTagName('hdt-progress-bar')[0];
    //           if (progressBar) {
    //             progressBar.attributes['aria-valuemax'].value = variant.price;
    //             const valueMax = progressBar.attributes['aria-valuemax'].value;
    //             const valueNow = progressBar.attributes['aria-valuenow'].value;
    //             progressBar.attributes['aria-valuenow'].value = valueNow;
    //             const toFreeValue = valueMax - valueNow;
                
    //             let state = '';
    //             const stateElem = document.getElementsByTagName('hdt-free-shipping-bar')[0];
    //             const messageContainer = document.querySelector('.hdt-progress-msg');
    //             if (toFreeValue > 0) {
    //               state = 'is-unreached';
    //               stateElem.classList.remove('is-success');
    //               stateElem.classList.add(state);

    //               let formatedMoney = SoccerTutor.countrySymbol + new Intl.NumberFormat('en-US', {
    //                 minimumFractionDigits: 2,
    //                 maximumFractionDigits: 2
    //               }).format(toFreeValue / 100);

    //               messageContainer.innerHTML = window.SoccerTutor.freeShippingTexts.inProgress.replace('{{ money }}', formatedMoney);
    //             } else {
    //               state = 'is-success';
    //               stateElem.classList.add(state);
    //               messageContainer.innerHTML = window.SoccerTutor.freeShippingTexts.success;
    //             }                
    //           }
    //           break;
    //         }
    //       }
          
    //     }
        
    //     if (selectedCountryCode && ! window.SoccerTutor.countriesListWithFreeShipping.includes(selectedCountryCode)) {
    //       removeFreeShippingBar();
    //     } else {
    //       showFreeShippingBar();
    //     }
    //   });
    // }

    // if (cartPageFormSelector.value && ) {
      
    // }
    //window.SoccerTutor.countryCode
    let country;
    if (cartPageFormSelector) {
      country = sessionStorage.getItem('calc_country') || cartPageFormSelector.value;
    } else {
      country = sessionStorage.getItem('calc_country')
    }
    country = country ? country.replace(/And/, '&amp;') : 'undefined';
    let localizationCode;
    if (typeof countriesInfo === 'undefined') {
      localizationCode = window.SoccerTutor.countryCode;
    } else {
      localizationCode = countriesInfo[country];
    }
    if (localizationCode && ! window.SoccerTutor.countriesListWithFreeShipping?.includes(localizationCode)) {
      removeFreeShippingBar();
    } else {
      showFreeShippingBar();
    }
  })();
  
  function addPageReloadCallback(elem, eventType) {
    if (elem.closest('.hdt-cart-item')?.querySelector('.hdt-cart-item__product .hdt-page-cart__meta-variant')?.innerText !== 'Paperback + eBook') {
      elem.addEventListener(eventType, () => {
        setTimeout(function() {
          location.reload();
        }, 1000);
      })
    }
  }
  
  document.querySelectorAll('.hdt-page-cart button.hdt-quantity__button').forEach((button) => {addPageReloadCallback(button, 'click')});
  document.querySelectorAll('.hdt-page-cart a.hdt-page-cart__remove').forEach((button) => {addPageReloadCallback(button, 'click')});
  document.querySelectorAll('.hdt-page-cart input.hdt-quantity-input').forEach((input) => {addPageReloadCallback(input, 'change')});

});
